// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___3UZHI","policy":"policy___39bc5","header":"header___1JRrB","PolicyFullScreenBtn":"PolicyFullScreenBtn___3dAjC","ModalTile":"ModalTile___6wdvE"};